import { Box, Button } from '@mui/material'
import {styled} from '@mui/material'
import { useEffect } from 'react';
import { useInterestedFilterStore } from 'src/stores/InterestedStore';


// 필터 버튼 스타일
const FilterButton = styled(Button)(({ theme }) => ({
    margin: "5px",
    borderRadius: "20px",
    '&.selected': {
    backgroundColor: "rgba(57, 185, 91, 0.05)", // #39B95B의 5% 투명도 적용
    color: 'rgba(6, 121, 155, 1)',                        // 테두리와 글씨 색상
    border: '1px solid rgba(6, 121, 155, 1)'         // 테두리 색상
    },
    '&.unselected': {
    backgroundColor: 'white',
    color: 'black',
    border: `1.5px solid ${theme.palette.grey[400]}`,
    },
}));

const TitleWrapper = styled('span')(({theme})=>({
    fontSize:'16px',
    fontWeight:500,
}))

const ToggleTagStatus = () => {
    const temp_status = useInterestedFilterStore((state)=>state.temp_status)
    const toggleFilter = useInterestedFilterStore((state)=>state.toggleFilter)
    const syncField = useInterestedFilterStore((state)=>state.syncField)
    useEffect(()=>{
        syncField('status','temp','base')
    },[])
        const mapStatus: Record<number,string>={
        0 : '전체',
        1 : '관심없음',
        2 : '관심',
        3 : '지원준비',
        4 : '지원완료',
        5 : '임관',
        }


  return (
    <>
        <TitleWrapper>
            상태
        </TitleWrapper>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: "5px", mb: 2 }}>
            {[0, 1, 2, 3, 4, 5]
                .map(note => (
                <FilterButton
                    key={note}
                    onClick={() => toggleFilter("temp_status", note, 0)}
                    className={temp_status.includes(note) ? "selected" : "unselected"}
                >
                    {mapStatus[note]}
                </FilterButton>
                ))}
            </Box>
    </>
  )
}

export default ToggleTagStatus